import {faTimesCircle, faCheckCircle} from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';

import {Icon} from '../Icon';
import {Spinner} from '../Spinner/Spinner';

import type {MutationStatus} from '@tanstack/react-query';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  status: MutationStatus;
  handleClipboard: () => Promise<void>;
  spinnerSize?: React.ComponentProps<typeof Spinner>['size'];
};
export function ClipboardButton({
  status,
  handleClipboard,
  className,
  spinnerSize,
  ...props
}: Props): React.JSX.Element {
  return (
    <button
      {...props}
      className={clsx('btn-secondary', className)}
      onClick={handleClipboard}
    >
      Copy CSV to Clipboard
      {status === 'pending' && <Spinner className="ml-2" size={spinnerSize} />}
      {status === 'error' && (
        <Icon icon={faTimesCircle} className="btn-icon-trailing text-tomato9" />
      )}
      {status === 'success' && (
        <Icon icon={faCheckCircle} className="btn-icon-trailing text-grass9" />
      )}
    </button>
  );
}

ClipboardButton.displayName = 'ClipboardButton';
